import BaseHeaderMcom from './BaseHeader.mcom';
import BaseHeaderBcom from './BaseHeader.bcom';

export default import.meta.env.VITE_ENTRY_POINT === 'bcom' ? BaseHeaderBcom : BaseHeaderMcom;
